import { adminPartnerQueryKeys as e } from "./useAdminPartnerQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminPartnersApi as n } from "@maat/api-main";
//#region src/partners/admin/useAdminPartnerQuery.ts
var r = (r) => t({
	queryKey: e.detail(r),
	queryFn: () => n.get(r),
	enabled: !!r
});
//#endregion
export { r as useAdminPartnerQuery };
